import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/affiliatetheme': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M159.7 237.4c-51.3 70.9-116.6 110.8-145.7 89.2-29.2-21.7-11.2-96.6 40.2-167.5 51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zM510.9 180.1c0.7 8.2 1.1 16.5 1 25 0 151.8-121.6 274.9-271.6 274.9-82.9 0-157.2-37.6-207-96.9 71.3-19.4 130.5-68.4 164.1-133.2 7.7 32.6 24 58.6 49 73.8 72.6 44.1 190.7-20.2 264.5-143.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/affiliatetheme.js
// module id = 696
// module chunks = 0